export default __webpack_public_path__ + "static/policy1-2c70323555f5f2c245fdfb3bbcad9e08.jpg";